<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 261.8 226.7"
    :width="width"
    :height="width"
  >
    <path
      :fill="iconColor"
      d="M161.1 0l-30.2 52.4L100.6 0H0l130.9 226.7L261.7 0z"
    ></path>
    <path
      fill="#48866a"
      d="M161.1 0l-30.2 52.4L100.6 0H52.3L131 136 209.4 0z"
    ></path>
  </svg>
</template>

<script>
export default {
  name: "VueIcon",
  props: {
    width: {
      type: [Number, String],
      default: 18
    },
    iconColor: {
      type: String,
      default: "currentColor"
    }
  }
};
</script>

<style scoped></style>
